










































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs,
  useRouter
} from '~/utils/nuxt3-migration'
import AuditAppointmentForm from '~/components/shared/audits/request/AuditAppointmentForm.vue'
import { AuditRequest, AuditRequestStatusStatus } from '~/models/audit/request'
import { parseDate } from '~/utils/date'
import { SIMPLE_DATETIME_FORMAT } from '~/constants/date'
import { useTime } from '~/compositions/datetime/time'
import CancelAuditButton from '~/components/shared/audits/request/timeline/CancelAuditButton.vue'
import { ciAudit } from '~/icons/source/regular/audit'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  props: {
    auditRequest: {
      type: Object as PropType<AuditRequest>,
      required: true
    }
  },
  components: { CancelAuditButton, AuditAppointmentForm },
  setup(props, { emit }) {
    const { auditRequest } = toRefs(props)
    const appointmentFormIsShown = ref(false)
    const router = useRouter()
    const { extractTimeFromDatetimeString } = useTime()
    const { t } = useI18n()

    const appointmentDate = computed(() => {
      if (auditRequest.value.activeAppointment.appointmentDate) {
        return parseDate(
          auditRequest.value.activeAppointment.appointmentDate,
          SIMPLE_DATETIME_FORMAT
        )
      }

      return new Date()
    })

    const appointmentTime = computed(() => {
      if (auditRequest.value.activeAppointment.appointmentDate) {
        return extractTimeFromDatetimeString(
          auditRequest.value.activeAppointment.appointmentDate
        )
      }
      return '09:00'
    })

    function handleAppointmentRescheduleSuccess() {
      appointmentFormIsShown.value = false
      emit('change-status', AuditRequestStatusStatus.PENDING_AUDIT)
    }

    const to = computed(() => {
      if (auditRequest.value.certificate?.finalized === false) {
        return {
          name: `__account_audits_external_certificates_edit`,
          params: { reportId: auditRequest.value.certificate.reportId },
          query: {
            requestId: auditRequest.value.id,
            category: auditRequest.value.auditPackage.category.id,
            lock: 1
          }
        }
      }

      return {
        name: '__account_audits_external_certificates_new',
        query: {
          requestId: auditRequest.value.id,
          category: auditRequest.value.auditPackage.category.id,
          lock: 1
        }
      }
    })

    const href = computed(() => {
      return router.resolve(to.value).href
    })

    const btnLabel = computed(() => {
      if (auditRequest.value.certificate?.finalized === false) {
        return t('edit external certificate')
      }
      return t('new external certificate')
    })

    return {
      appointmentFormIsShown,
      handleAppointmentRescheduleSuccess,
      appointmentDate,
      appointmentTime,
      to,
      href,
      btnLabel,
      ciAudit
    }
  }
})
